import type { PartnerCockpitNotification } from '@houzy/schemas/partner-cockpit/notifications';
import { useEffect, useRef } from 'react';

import { useMarkNotificationAsRead } from '../api/notificationsApi';
import { notificationLinkOptions } from '../utils/notificationLink';

export function useAutoReadInformationalNotifications(notifications: PartnerCockpitNotification[] | undefined): void {
    const { mutate } = useMarkNotificationAsRead();
    const requested = useRef(new Set<string>());

    useEffect(() => {
        for (const notification of notifications ?? []) {
            const isInformational = notificationLinkOptions(notification.action ?? undefined) === undefined;
            if (notification.read || !isInformational || requested.current.has(notification.uuid)) {
                continue;
            }
            requested.current.add(notification.uuid);
            mutate(notification.uuid, {
                onError: () => requested.current.delete(notification.uuid),
            });
        }
    }, [notifications, mutate]);
}
